<div class="bg-white rounded-lg border border-gray-200 p-8">
  <h1 class="text-2xl font-bold text-[#3abfad] mb-1">5. Últimas preguntas</h1>
  <p class="text-gray-600 mb-6">Estás a un paso de finalizar el proceso y obtener tu tarjeta.</p>

  <form class="space-y-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Región -->
      <div class="space-y-2">
        <label for="region" class="block text-sm font-medium">
          ¿En qué región vives?<span class="text-red-500">*</span>
        </label>
        <select [(ngModel)]="region" name="region" class="form-select w-full">
          <option *ngFor="let region of REGIONES" [value]="region.value">
            {{region.label}}
          </option>
        </select>
      </div>

      <!-- Comuna -->
      <div class="space-y-2">
        <label for="comuna" class="block text-sm font-medium">
          ¿Cuál es tu comuna de residencia?<span class="text-red-500">*</span>
        </label>
        <select [(ngModel)]="comuna" name="comuna" class="form-select w-full">
          <option *ngFor="let comuna of COMUNAS" [value]="comuna.value">
            {{comuna.label}}
          </option>
        </select>
      </div>

      <!-- Nombre de la calle -->
      <div class="space-y-2">
        <label for="calle" class="block text-sm font-medium">
          ¿Cuál es el nombre de la calle?<span class="text-red-500">*</span>
        </label>
        <input type="text" id="calle" [(ngModel)]="calle" name="calle" class="form-control w-full" placeholder="AVENIDA MACUL">
      </div>

      <!-- Número calle -->
      <div class="space-y-2">
        <label for="numero" class="block text-sm font-medium">
          Número calle<span class="text-red-500">*</span>
        </label>
        <input type="text" id="numero" [(ngModel)]="numero" name="numero" class="form-control w-full" placeholder="1234">
      </div>

      <!-- Depto/Block -->
      <div class="space-y-2">
        <label for="depto" class="block text-sm font-medium">
          Depto/Block
        </label>
        <input type="text" id="depto" [(ngModel)]="depto" name="depto" class="form-control w-full" placeholder="AVENIDA MACUL">
      </div>

      <!-- Nacionalidad -->
      <div class="space-y-2">
        <label for="nacionalidad" class="block text-sm font-medium">
          Nacionalidad<span class="text-red-500">*</span>
        </label>
        <select [(ngModel)]="nacionalidad" name="nacionalidad" class="form-select w-full">
          <option *ngFor="let nacionalidad of NACIONALIDADES" [value]="nacionalidad.value">
            {{nacionalidad.label}}
          </option>
        </select>
      </div>

      <!-- Estado civil -->
      <div class="space-y-2">
        <label for="estado-civil" class="block text-sm font-medium">
          Estado civil<span class="text-red-500">*</span>
        </label>
        <select [(ngModel)]="estadoCivil" name="estadoCivil" class="form-select w-full">
          <option *ngFor="let estado of ESTADOS_CIVILES" [value]="estado.value">
            {{estado.label}}
          </option>
        </select>
      </div>

      <!-- Género -->
      <div class="space-y-2">
        <label for="genero" class="block text-sm font-medium">
          Género<span class="text-red-500">*</span>
        </label>
        <select [(ngModel)]="genero" name="genero" class="form-select w-full">
          <option *ngFor="let genero of GENEROS" [value]="genero.value">
            {{genero.label}}
          </option>
        </select>
      </div>
    </div>

    <!-- Día de pago -->
    <div class="space-y-4">
      <label class="block text-sm font-medium">
        ¿Qué día del mes te acomoda pagar tu estado de cuenta?<span class="text-red-500">*</span>
      </label>
      <div class="flex gap-6">
        <div *ngFor="let dia of DIAS_PAGO" class="flex items-center space-x-2">
          <input type="radio" [id]="'dia-' + dia.value" [value]="dia.value" [(ngModel)]="diaPago" name="diaPago" (change)="onDiaPagoChange(dia.value)">
          <label [for]="'dia-' + dia.value">{{dia.label}}</label>
        </div>
      </div>
    </div>

    <!-- Estado de cuenta -->
    <div class="space-y-2">
      <label for="estado-cuenta" class="block text-sm font-medium">
        ¿Dónde quieres recibir tu estado de cuenta?<span class="text-red-500">*</span>
      </label>
      <select [(ngModel)]="estadoCuenta" name="estadoCuenta" class="form-select w-full">
        <option *ngFor="let opcion of ESTADO_CUENTA_OPTIONS" [value]="opcion.value">
          {{opcion.label}}
        </option>
      </select>
    </div>

    <!-- Nota informativa -->
    <p class="text-xs text-gray-500 italic mt-6">
      *Esta información es necesaria para completar tu perfil y ofrecerte las mejores beneficios.
    </p>
  </form>
</div> 